import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ReactComponent as PriceGuaranteeBadge } from '../../../assets/images/svg/price-guarantee-badge.svg';
import { pxToRem } from '../../../assets/styles/helper';
import themeColors from '../../../assets/styles/themeColors';
import { variables } from '../../../assets/styles/variables';
import { formatMoneyNumeral } from '../../../util/helpers/numeralHelpers';

const Card = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${themeColors.colorPrimary};
  border-radius: ${pxToRem(4)};
  padding: ${pxToRem(14)} ${pxToRem(16)};
  background: ${themeColors.colorBackgroundSecondary};
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${pxToRem(8)};
`;

const Title = styled.div`
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: ${pxToRem(15)};
  font-weight: 700;
  color: ${themeColors.colorTextPrimary};
`;

const LockLine = styled.div`
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: ${pxToRem(13)};
  color: ${themeColors.colorTextSecondary};
  margin-top: ${pxToRem(2)};
`;

const PreAuthLine = styled.div`
  margin-top: ${pxToRem(14)};
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: ${pxToRem(13)};
  font-weight: 700;
  color: ${themeColors.colorPreAuthOrange};
`;

const LearnMoreButton = styled.button`
  align-self: flex-start;
  margin-top: ${pxToRem(4)};
  background: none;
  border: none;
  padding: 0;
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: ${pxToRem(13)};
  font-weight: 400;
  color: ${themeColors.colorPrimary};
  text-decoration: underline;
  cursor: pointer;
`;

const SellFromHomePriceGuaranteeCard = ({ price, onLearnMore }) => {
  const { t } = useTranslation();

  return (
    <Card data-cy="card-sfh-price-guarantee">
      <TitleRow>
        <PriceGuaranteeBadge />
        <Title>{t('sellWizard.sfhWizard.quantity.priceGuarantee')}</Title>
      </TitleRow>
      <LockLine>
        {t('sellWizard.sfhWizard.quantity.lockPerUnit', {
          price: formatMoneyNumeral(price),
        })}
      </LockLine>
      <PreAuthLine>{t('sellWizard.sfhWizard.quantity.preAuth')}</PreAuthLine>
      <LearnMoreButton type="button" onClick={onLearnMore}>
        {t('sellWizard.sfhWizard.quantity.learnMore')}
      </LearnMoreButton>
    </Card>
  );
};

SellFromHomePriceGuaranteeCard.propTypes = {
  price: PropTypes.number,
  onLearnMore: PropTypes.func.isRequired,
};

export default SellFromHomePriceGuaranteeCard;
